export default "__VITE_ASSET__gX7bQUww__"